// Confidence score.
//
// Extracted from MockExam.js on 2026-09-15 so the home page and the premium
// dashboard compute it the same way. Two copies of this formula would drift,
// and the two surfaces showing different "confidence" numbers for the same
// results would be worse than showing none.
//
// Weighted mean of the last 5 scores, most recent weighted highest: someone who
// scored 40% then 80% is readier than the reverse, and a flat average hides
// that. Returns 0 with no results.

export function calculateConfidenceScore(userResults) {
    if (!userResults || userResults.length === 0) return 0;

    const lastFive = userResults.slice(-5);
    let weightedSum = 0;
    let totalWeight = 0;

    lastFive.forEach((result, index) => {
        const weight = index + 1; // most recent gets the highest weight
        weightedSum += result.score * weight;
        totalWeight += weight;
    });

    return Math.min(100, Math.round(weightedSum / totalWeight));
}

export default calculateConfidenceScore;
